<mat-card-header>
	<mat-card-title class="h5">
		Resolve Children Duplicates
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>

<div class="table-responsive margin-top-sm" *ngIf="!isLoading">
	<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1">

		<ng-container matColumnDef="CODE">
			<mat-header-cell *matHeaderCellDef> Region </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a [routerLink]="'/children/deduplication/region/' + element.CODE">
					{{element.CODE}}</a>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="UNRESOLVED">
			<mat-header-cell *matHeaderCellDef> Unresolved </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a [routerLink]="'/children/deduplication/region/' + element.CODE + '/unresolved'">
					{{element.UNRESOLVED}}</a>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="RESOLVED">
			<mat-header-cell *matHeaderCellDef> Resolved </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a [routerLink]="'/children/deduplication/region/' + element.CODE + '/resolved'">
					{{element.RESOLVED}}</a>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>
</div>